var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPublished({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1965)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.875 9.75C13.35 9.75 10.5 12.6 10.5 16.125C10.5 19.65 13.35 22.5 16.875 22.5C20.4 22.5 23.25 19.65 23.25 16.125C23.25 12.6 20.4 9.75 16.875 9.75ZM21.75 15.75H19.5C19.5 14.25 19.275 12.75 18.825 11.625C20.4 12.375 21.6 13.875 21.75 15.75ZM16.875 21C16.575 20.85 15.9 19.65 15.75 17.25H17.925C17.775 19.65 17.175 20.85 16.875 21ZM15.75 15.75C15.825 12.9 16.575 11.4 16.8 11.25C17.1 11.4 17.85 12.9 17.925 15.75H15.75ZM14.925 11.625C14.475 12.75 14.325 14.25 14.25 15.75H12C12.15 13.875 13.35 12.375 14.925 11.625ZM12.15 17.25H14.25C14.325 18.45 14.55 19.65 14.925 20.625C13.575 20.025 12.525 18.75 12.15 17.25ZM18.825 20.625C19.2 19.65 19.425 18.525 19.5 17.25H21.675C21.225 18.75 20.175 20.025 18.825 20.625Z",
    fill: "black",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.35 7.5C18.675 4.05 15.6 1.5 12 1.5C8.4 1.5 5.325 4.05 4.65 7.575C2.025 8.1 0 10.35 0 13.125C0 16.2 2.55 18.75 5.625 18.75H8.25V17.25H5.625C3.375 17.25 1.5 15.375 1.5 13.125C1.5 10.95 3.15 9.15 5.325 9H6V8.325C6.375 5.325 8.925 3 12 3C14.775 3 17.1 4.95 17.775 7.5H19.35Z",
    fill: "black",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1965"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublished);
export default __webpack_public_path__ + "static/media/published.2830572618e204f1bc093dfba722a0ff.svg";
export { ForwardRef as ReactComponent };